import { useState, useEffect } from "react";
import { Route, Routes, Link, useLocation } from "react-router-dom";
import moment from "moment";
import "moment/locale/ru";
import { Nav, NavItem, NavLink } from "react-bootstrap";

import { FetchService } from "../../API/FetchService.js";
import { RenderAnimation } from "../Animation/Animation.jsx";
import { FetchComponent } from "../FetchComponent/FetchComponent.jsx";

import { ScheduleTable } from "./ScheduleTable/ScheduleTable.jsx";
import { ScheduleSwitchers } from "./ScheduleSwitchers/ScheduleSwitchers.jsx";
import { ScheduleDescription } from "./ScheduleDescription/ScheduleDescription.jsx";

export const Schedule = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const changeNavPath = location.pathname === "/schedule/" ? "/" : "forming/";
  const isForming = location.pathname.includes("forming");
  const [week, setWeek] = useState(0);
  const [date, setDate] = useState({
    today: moment(),
    activeDay: moment().day(),
    startOfWeek: moment().startOf("week"),
    endOfWeek: moment().endOf("week"),
    dateArray: [],
  });

  const [lessons, setLessons] = useState({
    data: [],
    loading: true,
    error: false,
  });
  const [branches, setBranches] = useState({
    data: [],
    loading: true,
    error: false,
    currentBranch: null,
  });
  const [modules, setModules] = useState({
    data: [],
    loading: true,
    error: false,
    currentModule: params.get("module") || "",
  });

  useEffect(() => {
    Promise.all([
      new FetchService().getModules(),
      new FetchService().getBranches(),
    ])
      .then(([modulesResponse, branchesResponse]) => {
        setModules((prev) => {
          return {
            ...prev,
            data: modulesResponse.data,
          };
        });
        setBranches((prev) => {
          return {
            ...prev,
            data: branchesResponse.data,
            currentBranch: branches.currentBranch
              ? branches.currentBranch
              : branchesResponse.data[0]?.ref,
          };
        });
      })
      .catch(() => {
        setModules((prev) => {
          return {
            ...prev,
            error: true,
          };
        });
        setBranches((prev) => {
          return {
            ...prev,
            error: true,
          };
        });
      })
      .finally(() => {
        setModules((prev) => {
          return {
            ...prev,
            loading: false,
          };
        });
        setBranches((prev) => {
          return {
            ...prev,
            loading: false,
          };
        });
      });
  }, []);

  useEffect(() => {
    setLessons((prev) => {
      return {
        ...prev,
        loading: true,
        error: false,
      };
    });
    if (branches.currentBranch) {
      const currentPath = isForming
        ? new FetchService({
            week,
            branch: branches.currentBranch,
          }).getFormingLessons()
        : new FetchService({
            week,
            branch: branches.currentBranch,
          }).getRegularLessons();

      currentPath
        .then(({ data }) => {
          setLessons((prev) => {
            return { ...prev, data };
          });
        })
        .catch(() => {
          setLessons((prev) => {
            return { ...prev, error: true };
          });
        })
        .finally(() => {
          setLessons((prev) => {
            return { ...prev, loading: false };
          });
        });
    }
  }, [week, branches.currentBranch, isForming]);

  useEffect(() => {
    const dateArray = [];
    const startOfWeek = date.today.clone().startOf("week");
    const endOfWeek = date.today.clone().endOf("week");
    let day = startOfWeek;

    while (day <= endOfWeek) {
      dateArray.push(day);
      day = day.clone().add(1, "d");
    }

    setDate({ ...date, startOfWeek, endOfWeek, dateArray });
  }, [date.today]);

  return (
    <div className="mt-3">
      <RenderAnimation>
        <Nav
          className="justify-content-center align-items-center"
          fill
          variant="pills"
          defaultActiveKey={changeNavPath}
        >
          <NavItem className="col-sm-5">
            <Link to="">
              <NavLink as="div" eventKey="/">
                <span>Действующие расписание</span>
              </NavLink>
            </Link>
          </NavItem>
          <NavItem className="col-sm-5 mt-2 mt-sm-0">
            <Link to="forming/">
              <NavLink as="div" eventKey="forming/">
                <span>Расписание формирующихся групп</span>
              </NavLink>
            </Link>
          </NavItem>
        </Nav>
      </RenderAnimation>

      <div className="mt-3">
        <ScheduleSwitchers
          setWeek={setWeek}
          branches={branches}
          setBranches={setBranches}
          modules={modules}
          setModules={setModules}
          setDate={setDate}
          date={date}
        />
        <FetchComponent
          keyAnimation={
            location.key +
            week +
            branches.currentBranch +
            modules.currentModule +
            lessons.loading
          }
          loading={lessons.loading}
          error={lessons.error}
          heightContainer="80vh"
        >
          <Routes location={location}>
            <Route
              path="/"
              element={
                <ScheduleTable
                  date={date}
                  data={lessons.data}
                  module={modules.currentModule}
                  setDate={setDate}
                />
              }
            />
            <Route
              path="forming/"
              element={
                <ScheduleTable
                  date={date}
                  data={lessons.data}
                  module={modules.currentModule}
                  setDate={setDate}
                  isForming
                />
              }
            />
          </Routes>
        </FetchComponent>
        <RenderAnimation>
          {!!modules.data.length && (
            <ScheduleDescription moduleList={modules.data} />
          )}
        </RenderAnimation>
      </div>
    </div>
  );
};
